import createSvgIcon from '../Utils/CreateSvgIcon';

export const BodyColorYellow = createSvgIcon(
  <circle cx="10" cy="10" fill="#FAC361" r="10" transform="matrix(1 0 0 -1 2 22)" />,
  'BodyColorYellow',
);
